import { QueryResource, QueryResourceRelationship, _QueryResources } from '@/lib/datx-jsonapi-react';
import { ThinLecture } from '@/resources/ThinLecture';

export const queryThinLectureWithTag = (lectureId: string): QueryResource<ThinLecture> => () =>
  lectureId && [
    ThinLecture,
    lectureId,
    {
      include: ['tag'],
    },
  ];

export const queryThinLectureWithTagAndEvent = (lectureId: string): QueryResource<ThinLecture> => () =>
  lectureId && [
    ThinLecture,
    lectureId,
    {
      include: ['tag', 'event'],
    },
  ];

export const queryThinLecture = (lectureId: string, include: Array<string>): QueryResource<ThinLecture> => () =>
  lectureId && [
    ThinLecture,
    lectureId,
    {
      include,
    },
  ];

export const queryLectureSimilarRelationship = (lectureId: string): QueryResourceRelationship<ThinLecture> => () =>
  lectureId
    ? [
        ThinLecture,
        lectureId,
        'similar',
        {
          include: ['tag', 'sorted_profiles'],
          filter: {
            library: 'true',
            scope: 'published',
          },
          params: [
            { key: 'page[size]', value: '1' },
            { key: 'page[number]', value: '1' },
          ],
        },
      ]
    : null;

export const querySubsequentLecture = (lectureId: string): _QueryResources<ThinLecture> | null => {
  return lectureId
    ? [
        ThinLecture,
        {
          include: ['tag', 'sorted_profiles', 'event'],
          filter: {
            subsequent_lecture_id: lectureId,
            library: 'true',
            scope: 'published',
          },
        },
      ]
    : null;
};
